<template>
  <div>
    <!-- {{ $t('form.missPassword') }} -->
    <header ref="siteHeaderRef" class="site-header" :class="menuFixed">
      <div class="container">
        <div class="row header-row">
          <!-- search -->
          <div class="col-4 col-4-sm search-wrapper">
            <a href="#" class="icon-btn" :aria-label="$t('header.search')" @click.prevent="toggleSearch">
              <img src="@/assets/img/search.svg" alt="" />
            </a>
            <div v-show="showSearchInput" class="desktop-search-container">
              <input
                ref="desktopSearchInputRef"
                v-model="searchQuery"
                type="text"
                class="desktop-search-input"
                :placeholder="$t('header.search')"
              />
              <button class="search-btn" @click="handleSearch">
                <span class="yellow-text">{{ $t('header.searchSubmit') }}</span>
              </button>
              <button class="close-btn" @click.prevent="toggleSearch">
                <span class="yellow-text">{{ $t('header.close') }}</span>
              </button>
            </div>
          </div>

          <!-- Logo -->
          <div class="col-4 col-4-sm">
            <a href="/" class="logo" :aria-label="$t('header.index')">
              <img src="@/assets/img/logo.png" alt="Pocket Poker Logo" />
            </a>
          </div>

          <!-- Icons -->
          <div class="col-4 col-4-sm header-icons">
            <div class="icon-btn">
              <img src="@/assets/img/language.svg" alt="Pocket Poker Logo" />
              <select :value="locale" class="language-select-desktop" @change="handleLanguageChange">
                <option v-for="option in LOCALE_OPTIONS" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <a href="#" class="icon-btn" :aria-label="$t('header.serviceStaff')">
              <img src="../../assets/img/frame.svg" alt="" />
            </a>
            <div class="wrapper menu-btn" @click="handleMenuBtn">
              <div ref="menuBtnRef" class="menu-toggle ex-spin">
                <span class="bar upper"></span>
                <span class="bar middle"></span>
                <span class="bar lower"></span>
              </div>
            </div>
          </div>
        </div>
        <div ref="mobileMenuRef" class="row header-row">
          <nav class="col-12 hidden-sm header-menu">
            <!--search -->
            <div class="search-container">
              <div class="search-icon">
                <svg viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              </div>
              <input v-model="searchQuery" type="text" class="search-input" :placeholder="$t('header.search')" />
              <button class="search-submit-btn" @click="handleSearch">{{ $t('header.searchSubmit') }}</button>
            </div>
            <ul class="nav-list">
              <li>
                <NuxtLink to="/" exact-active-class="active" @click.prevent="goHome">
                  {{ $t('header.index') }}
                </NuxtLink>
              </li>
              <li>
                <a href="#">{{ $t('header.bonus') }}</a>
              </li>
              <li>
                <a href="#">{{ $t('header.game') }}</a>
              </li>
              <li>
                <a href="#">{{ $t('header.clientSupport') }}</a>
              </li>
              <li>
                <a href="#">{{ $t('header.agent') }}</a>
              </li>
              <li>
                <a href="#">{{ $t('header.download') }}</a>
              </li>
            </ul>
            <div class="select-container">
              <div class="language-icon">
                <svg viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path
                    d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                  ></path>
                </svg>
              </div>
              <select :value="locale" class="language-select" @change="handleLanguageChange">
                <option v-for="option in LOCALE_OPTIONS" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
              <div class="arrow-icon">
                <svg viewBox="0 0 24 24">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div>
            <div class="service-container">
              <a href="#" class="icon-btn"
                ><img src="@/assets/img/frame.svg" alt="Pocket Poker Logo" />{{ $t('header.serviceStaff') }}</a
              >
            </div>
          </nav>
        </div>
      </div>
    </header>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, nextTick } from 'vue';
import { LOCALE_OPTIONS, saveLocale, isSupportedLocale } from '@i18n';

const { setLocale, locale } = useI18n();
const route = useRoute(); // 取得當前路由
const menuBtnRef = ref(null);
const mobileMenuRef = ref(null);
const siteHeaderRef = ref(null);

// 搜尋功能相關
const showSearchInput = ref(false);
const searchQuery = ref('');
const desktopSearchInputRef = ref<HTMLInputElement | null>(null);

const toggleSearch = async () => {
  // 清除搜尋欄位
  if (searchQuery.value) {
    searchQuery.value = '';
  }
  showSearchInput.value = !showSearchInput.value;
  if (showSearchInput.value) {
    await nextTick();
    desktopSearchInputRef.value?.focus();
  }
};

const handleSearch = () => {
  if (searchQuery.value.trim()) {
    console.log('搜尋:', searchQuery.value);
    // 這裡可以添加搜尋邏輯，例如跳轉到搜尋結果頁面
    // navigateTo(`/search?q=${encodeURIComponent(searchQuery.value)}`);
  }
};

const handleMenuBtn = async () => {
  // 清除搜尋欄位
  if (searchQuery.value) {
    searchQuery.value = '';
  }

  menuBtnRef.value.classList.toggle('clicked');
  mobileMenuRef.value.classList.toggle('mobile-show');

  await nextTick();

  const hasNoBackground = siteHeaderRef.value.classList.contains('no-background');
  const isMenuShow = mobileMenuRef.value.classList.contains('mobile-show');

  if (hasNoBackground) {
    siteHeaderRef.value.classList.toggle('no-background-remove', isMenuShow);
  }
};

const closeMobileMenu = () => {
  menuBtnRef.value?.classList.remove('clicked');
  mobileMenuRef.value?.classList.remove('mobile-show');
  siteHeaderRef.value?.classList.remove('no-background-remove');
};

const goHome = () => {
  closeMobileMenu();
  return navigateTo('/');
};

const menuFixed = computed(() => {
  const noBackgroundPaths = ['/privacy', '/service'];
  return noBackgroundPaths.includes(route.path) ? 'no-background' : 'header-fixed';
});
const handleLanguageChange = (event: Event) => {
  const newLocale = (event.target as HTMLSelectElement).value;
  if (!isSupportedLocale(newLocale)) return;

  console.log('選擇的語言:', newLocale);
  setLocale(newLocale);
  saveLocale(newLocale); // 儲存語系到 localStorage
};
</script>
<style lang="scss">
@use '@/assets/css/main.scss' as *;
@use 'sass:color';

main {
  background: $color-bg-dark !important;
}

.site-header {
  @media screen and (max-width: $breakpoint-mobile) {
    &.no-background .header-row {
      // background: none !important;
    }
  }
  .container {
    @media screen and (max-width: $breakpoint-mobile) {
      width: 100%;
    }
  }
  .header-row {
    padding: 0.75rem 0;
    .service-container {
      display: none;
    }
    @media screen and (max-width: $breakpoint-mobile) {
      background: $color-bg-dark;
      padding: 0;

      .icon-btn,
      .icon-btn img {
        display: none !important;
      }
      .service-container {
        position: absolute;
        bottom: 40px;
        right: 20px;
        display: block;

        .icon-btn,
        .icon-btn img {
          display: block;
          margin-right: 2px;
          display: flex;
          align-items: center;
          color: $color-text-gray;
          font-size: 15px;
        }
      }
    }
  }

  .header-row:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #cecece;
    @media screen and (max-width: $breakpoint-mobile) {
      border-bottom: none;
    }
  }
  .header-row:nth-child(2) {
    display: block;
    @media screen and (max-width: $breakpoint-mobile) {
      display: none;
    }
  }
  .header-row:nth-child(2).mobile-show {
    display: block;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;

    img {
      height: 77px;
    }

    span {
      font-size: 1.25rem;
      font-weight: 700;
      letter-spacing: 0.05em;
      color: $color-text-dark;
    }
  }

  nav {
    text-align: center;

    .nav-list {
      display: flex;
      justify-content: center;
      gap: 4rem;
      margin: 0;
      padding: 0;
      list-style: none;

      a {
        font-family: 'Inter', Helvetica, Arial, sans-serif;
        color: $color-white;
        font-size: 0.95rem;
        font-weight: 500;
        text-decoration: none;
        display: inline-block;
        position: relative;
        transition: color 0.3s ease-in-out;
        cursor: pointer;

        &:hover,
        &.active {
          color: $color-gold;
        }

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -6px;
          width: 100%;
          height: 2px;
          background-color: $color-gold;
          transform: scaleX(0);
          transform-origin: left center;
          transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
        }

        &.active::after,
        &:hover::after,
        &:focus-visible::after {
          transform: scaleX(1);
        }
      }
    }
  }

  .header-icons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 18px;

    .icon-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;

      img {
        width: 26px;
        height: 26px;
      }
    }

    .menu-btn {
      display: none;
    }
  }

  /* 小螢幕調整 */
  @media (max-width: $breakpoint-mobile) {
    .header-row {
      flex-wrap: wrap;
    }

    nav.header-menu {
      width: 100%;
      background: $color-bg-dark;
      margin: 0;
      @media (max-width: $breakpoint-mobile) {
        padding: 10px 20px;
        height: calc(100vh - 48px);
      }
    }

    .header-icons {
      .menu-btn {
        display: inline-flex;
      }
    }

    .logo img {
      height: 32px;
    }
  }
}

.menu-toggle {
  width: 20px;
  cursor: pointer;
  display: inline-block;
}

.menu-toggle .bar {
  width: 100%;
  height: 3px;
  background: $color-primary;
  display: block;
  margin-bottom: 3px;
  border-radius: 3px;
}

.ex-spin .bar {
  transition: all 300ms;
}
.clicked.ex-spin .upper {
  transform: translateY(5px) rotate(45deg);
}
.clicked.ex-spin .middle {
  opacity: 0;
}
.clicked.ex-spin .lower {
  transform: translateY(-7px) rotate(-45deg);
}
.ex-spin.clicked .upper {
  transform: translateY(5px) rotate(405deg);
}

.header-fixed {
  background: $color-bg-dark !important;
}
.site-header {
  width: 100%;
  z-index: 1000;
  background: none;
  nav .nav-list {
    @media (max-width: $breakpoint-mobile) {
      flex-direction: column;
      gap: 0;
    }
    li {
      text-align: left;
      position: relative;
      @media (max-width: $breakpoint-mobile) {
        border-bottom: 1px solid $color-text-gray;
        &::before,
        &::after {
          content: '';
          position: absolute;
          width: 10px;
          height: 1.5px;
          background: $color-text-gray;
          top: 50%;
          transform: translateY(-50%);
        }
        &::before {
          transform: rotate(45deg);
          right: 0;
          margin-top: -6px;
        }
        &::after {
          transform: rotate(-45deg);
          right: 0;
        }
      }
      a {
        @media (max-width: $breakpoint-mobile) {
          color: $color-white;
          width: 100%;
          color: $color-text-gray;
          padding: 15px 0;
          display: inline-block;
          font-size: 15px;
          position: relative;
          &.active,
          &:hover {
            color: $color-text-gray !important;
            &::after {
              content: '';
              position: absolute;
              left: -20px;
              top: 50%;
              transform: translateY(-50%);
              width: 5px;
              height: 32px;
              background-color: #d9d9d9;
              border-bottom-right-radius: 5px;
              border-top-right-radius: 5px;
            }
          }
        }
      }
    }
  }
}

/* 手機版搜尋區塊樣式 - 現代玻璃擬態風格 */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  .icon-btn {
    display: inline-flex !important;
    cursor: pointer;
    transition: transform 0.2s ease;
    &:hover {
      transform: scale(1.1);
    }
    img {
      display: block !important;
    }
  }
}

.desktop-search-container {
  /* 1000px 以上 - 右側簡約底線樣式 */
  position: absolute;
  top: 50%;
  left: 50px;
  transform: translateY(-50%);
  width: 300px;
  padding: 0;
  background: transparent;
  backdrop-filter: none;
  border-radius: 0;
  box-shadow: none;
  border: none;
  display: flex;
  align-items: center;
  z-index: 1001;
  animation: searchSlideRight 0.3s ease-out;
  gap: 10px;

  /* 1024px 以下 - 全螢幕覆蓋 */
  @media screen and (max-width: $breakpoint-xlarge) {
    flex-direction: column;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    max-width: none;
    margin-left: 0;
    padding: 20px;
    background: $color-bg-dark;
    transform: none;
    animation: searchFadeIn 0.3s ease-out;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  /* 小手機 480px */
  @media screen and (max-width: $breakpoint-smaller) {
    padding: 10px 12px;
  }
}

@keyframes searchSlideRight {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes searchPopIn {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(-15px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}

@keyframes searchSlideDown {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes searchFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.desktop-search-input {
  /* 1000px 以上 - 簡約底線樣式 */
  flex: 1;
  padding: 8px 0;
  font-size: 14px;
  border: none;
  border-bottom: 2px solid #ccc;
  border-radius: 0;
  background: transparent;
  outline: none;
  transition: all 0.3s ease;
  color: $color-white;
  font-weight: 400;
  min-width: 0;

  &::placeholder {
    color: #999;
    font-weight: 400;
  }

  &:focus {
    border-color: $color-primary;
    background: transparent;
    box-shadow: none;
  }

  /* 1024px 以下全螢幕模式 */
  @media screen and (max-width: $breakpoint-xlarge) {
    flex: none;
    width: 100%;
    max-width: 500px;
    padding: 16px 0;
    font-size: 24px;
    border-bottom: 2px solid #ccc;
    text-align: center;

    &::placeholder {
      font-size: 20px;
      color: #bbb;
    }
  }

  /* 小手機 480px */
  @media screen and (max-width: $breakpoint-smaller) {
    font-size: 20px;
    padding: 14px 0;

    &::placeholder {
      font-size: 16px;
    }
  }
}

.search-btn,
.close-btn {
  /* 1000px 以上 - 圓角邊框按鈕 */
  padding: 8px 20px;
  border: 2px solid $color-primary;
  background: transparent;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
  background: $color-primary;

  .yellow-text {
    font-size: 13px;
    font-weight: 600;
    color: $color-white;
    letter-spacing: 0.5px;
    transition: color 0.3s ease;
  }

  &:hover {
    background: $color-primary;

    .yellow-text {
      color: $color-white;
    }
  }

  /* 1024px 以下全螢幕模式 - 圓形關閉按鈕在右上角 */
  @media screen and (max-width: $breakpoint-xlarge) {
    position: relative;
    width: 50px;
    height: 50px;
    padding: 0;
    border-radius: 50%;
    background: $color-white;
    border: 2px solid #e0e0e0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    z-index: 1002;

    .yellow-text {
      font-size: 12px;
      font-weight: 600;
      color: #666;
    }

    &:hover {
      background: $color-primary;
      border-color: transparent;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);

      .yellow-text {
        color: $color-white;
      }
    }
  }

  /* 小手機 480px */
  @media screen and (max-width: $breakpoint-smaller) {
    width: 44px;
    height: 44px;

    .yellow-text {
      font-size: 11px;
    }
  }
}

.close-btn {
  background: none;
  .yellow-text {
    color: $color-primary;
  }
  @media screen and (max-width: $breakpoint-xlarge) {
    position: fixed;
    top: 20px;
    right: 20px;
    border: none;
    box-shadow: none;

    .yellow-text {
      display: none;
    }

    &::before {
      content: '✕';
      font-size: 20px;
      font-weight: 300;
      color: #666;
      transition: color 0.3s ease;
    }

    &:hover::before {
      color: $color-white;
    }
  }

  @media screen and (max-width: $breakpoint-smaller) {
    &::before {
      font-size: 18px;
    }
  }
}

.search-btn {
  @media screen and (max-width: $breakpoint-xlarge) {
    width: auto;
    height: auto;
    padding: 12px 28px;
    border-radius: 25px;
    background: $color-primary;
    border: none;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);

    .yellow-text {
      font-size: 14px;
      font-weight: 600;
      color: $color-white;
      letter-spacing: 1px;
    }

    &:hover {
      background: color.adjust($color-primary, $lightness: -8%);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }

    &:active {
      transform: translateY(0);
    }
  }

  @media screen and (max-width: $breakpoint-smaller) {
    padding: 10px 24px;

    .yellow-text {
      font-size: 13px;
    }
  }
}

.search-container {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  display: none;
  @media (max-width: $breakpoint-mobile) {
    display: block;
  }
}

.search-input {
  width: 100%;
  padding: 9px 76px 9px 45px;
  font-size: 15px;
  border: 1px solid transparent;
  border-radius: 3px;
  background-color: rgba(239, 239, 239, 0.1);
  outline: none;
  transition: $transition-default;
  box-sizing: border-box;
  color: $color-text-gray;
  &::placeholder {
    color: $color-text-gray;
  }

  &:focus {
    background-color: $color-bg-light;
  }
}

.search-submit-btn {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  padding: 6px 14px;
  background: $color-primary;
  border: none;
  border-radius: 3px;
  color: $color-white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: color.adjust($color-primary, $lightness: -8%);
  }
}

.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.search-icon svg {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: $color-text-light;
  stroke-width: 2;
  stroke-linecap: round;
}
.select-container {
  position: relative;
  width: 100%;
  margin-top: 25px;
  display: none;
  @media (max-width: $breakpoint-mobile) {
    display: block;
  }
}

.language-select {
  width: 100%;
  padding: 9px 50px 9px 45px;
  font-size: 15px;
  border-radius: 3px;
  background-color: rgba(239, 239, 239, 0.1);
  outline: none;
  cursor: pointer;
  appearance: none;
  transition: $transition-default;
  box-sizing: border-box;
  color: $color-text-gray;
  text-align: right;
}
.language-select-desktop {
  margin-left: 7px;
  background-color: none;
  color: $color-white;
  font-size: 0.95rem;
  display: block;
  @media (max-width: $breakpoint-mobile) {
    display: none;
  }
}

.language-select:hover {
  border-color: #999;
}

.language-select:focus {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.language-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.language-icon svg {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: $color-text-light;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.arrow-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 23px;
  height: 23px;
  pointer-events: none;
}

.arrow-icon svg {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: $color-text-light;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.no-background {
  background: none !important;
  position: absolute;
  top: 0;
  left: 0;
  nav .nav-list a {
    color: $color-white;
  }
  .language-select-desktop {
    color: $color-primary;
  }
  .desktop-search-input {
    color: $color-white;
  }
}

.no-background-remove {
  // background: $color-white !important;
}
</style>
